import { InjectionToken } from '@angular/core';
import packageJson from '../../../package.json';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const APP_VERSION = new InjectionToken<string>('app.version', {
  providedIn: 'root',
  factory: (): string => packageJson.version,
});
